import { render, staticRenderFns } from "./tab-status.vue?vue&type=template&id=05ea1d92&scoped=true"
import script from "./tab-status.vue?vue&type=script&lang=js"
export * from "./tab-status.vue?vue&type=script&lang=js"
import style0 from "./tab-status.vue?vue&type=style&index=0&id=05ea1d92&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea1d92",
  null
  
)

export default component.exports